import { render, staticRenderFns } from "./Experts.vue?vue&type=template&id=488da9fb&scoped=true"
import script from "./Experts.vue?vue&type=script&lang=js"
export * from "./Experts.vue?vue&type=script&lang=js"
import style0 from "./Experts.vue?vue&type=style&index=0&id=488da9fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488da9fb",
  null
  
)

export default component.exports